import React from "react";
import {Box, TextFieldWithSelect, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const SELECT_INPUT_DATA = [
  {
    title: "USA",
    value: "+1(555)",
  },
  {
    title: "BAN",
    value: "+880",
  },
  {
    title: "CHINA",
    value: "+86",
  },
];

const TextFieldWithSelectPage = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic TextField with select
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          language={"js"}
          value={
            "const SELECT_INPUT_DATA = [\n" +
            "  {\n" +
            '    title: "USA",\n' +
            '    value: "+1(555)",\n' +
            "  },\n" +
            "  {\n" +
            '    title: "BAN",\n' +
            '    value: "+880",\n' +
            "  },\n" +
            "  {\n" +
            '    title: "CHINA",\n' +
            '    value: "+86",\n' +
            "  },\n" +
            "];\n\n\n" +
            "<TextFieldWithSelect options={SELECT_INPUT_DATA} label={'Phone Number'} type={'number'} fullWidth />"
          }
        >
          <Box width={300}>
            <TextFieldWithSelect
              options={SELECT_INPUT_DATA}
              label={"Phone Number"}
              type={"number"}
              fullWidth
            />
          </Box>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default TextFieldWithSelectPage;
